import { Component, inject } from '@angular/core';
import { HeaderService } from '../../services/header.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'header-hamburger',
  templateUrl: './header-hamburger.component.html',
  styleUrls: ['./header-hamburger.component.scss'],
  standalone: true,
  imports: [CommonModule]
})
export class HeaderHamburgerComponent {
  public headerService = inject(HeaderService);
}
